<div class="d-flex">
    <div>
        <app-superadminsidenav></app-superadminsidenav>
    </div>

    <div style="
      height: 100vh;
      overflow: scroll;
      width: 100%;
      background-color: rgba(250, 250, 250, 1);
    ">

        <div style="padding-left: 10px" class="container">
            <div class="allergens-head">
                <h2>
                    {{title}}
                </h2>
            </div>

            <div class="containerResto">
                <div *ngIf="!showEditor">
                    <div class="container-head">
                        <span class="noOfRestoList">{{ dataSource?.data?.length || 0 }} Template</span>
                        <span class="resto-input">
                            <div style="padding: 2px">
                                <img src="../../../assets/images/Search.png" alt="" />
                                <input placeholder="Template name or ID" [(ngModel)]="searchText"
                                    (ngModelChange)="filter()" />
                            </div>
                        </span>
                    </div>
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 demo-table">
                        <!-- Position Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef class="table-head checking">
                                SL No.
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                                {{ i + 1 }}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef class="table-head checking">
                                Template Name
                            </th>
                            <td mat-cell *matCellDef="let element" class="table-element">
                                {{ element.template_name }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="table-head checking" style="text-align:center">
                                Action
                            </th>
                            <td mat-cell *matCellDef="let element" class="table-element" style="text-align:center">
                                <img src="../../../assets/images/editIcon.png" alt="" class="edit-element"
                                    (click)="showEmailEditor(element)" />
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>



                </div>









                <div *ngIf="showEditor">
                    <div style="padding: 16px;">
                        <button type="button" class="close_btn" (click)="closeEditor()">← Back</button>
                    </div>

                    <app-email-template-editor [emailData]="emailData"
                        (onSubmit)="refresh()"></app-email-template-editor>
                </div>
            </div>
        </div>